import {
  IconButton as MuiIconButton,
  buttonClasses,
  styled,
} from '@mui/material';

export const Input = styled('input')`
  appearance: none;
  outline: none;
  border: none;
  background: rgba(0, 0, 0, 0);;
  color: #FFF;
  width: 30px;
  height: 24px;
  font-weight: 500;
  font-size: 16px;
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const Box = styled('div')`
  position: absolute;
  display: flex;
  align-items: center;
  background: rgba(133, 133, 134, .5);
  border-radius: 4px;
  color: #FFF;
  top: 10px;
  right: 10px;
  z-index: 1;
  font-weight: 500;
  font-size: 16px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &:focus, &:hover {
    background: rgba(78, 78, 78, .5);
  }
`

export const IconButton = styled(MuiIconButton)((props) => {
  const { theme: { palette: { text } } } = props;
  return {
    padding: '13px',
    path: {
      fill: '#FFF',
    },
    [`&.${buttonClasses.disabled}`]: {
      path: {
        fill: text.secondary,
      },
    },
  };
});
